"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const locales_1 = tslib_1.__importDefault(require("./locales"));
// import { MARKET_ID_MAP } from './conf';
const utils_1 = require("../assets/utils");
const __sfc_main = {};
__sfc_main.props = {
    optionInfo: {
        type: Object,
        default: ''
    },
    langText: {
        type: String,
        default: ''
    },
    rateColorCls: {
        type: String,
        default: ''
    }
};
__sfc_main.setup = (__props, __ctx) => {
    var _a;
    const { useTeleport, useI18n } = require('@fegobull/webapi').use;
    const { ftReport } = ((_a = window.FEGORender) === null || _a === void 0 ? void 0 : _a.plugins) || {};
    const $tran = useI18n(locales_1.default);
    useTeleport(document.body);
    const isEN = (0, utils_1.useIsEN)();
    const isJP = (0, utils_1.useIsJP)();
    const props = __props;
    const toStock = async (evt) => {
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `期权弹窗_股票_${props.optionInfo.stockId}`
        });
        window.location.href = `futumm://quote/stockDetailV2?stockID=${props.optionInfo.stockId}`;
    };
    const toOption = async (evt) => {
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `期权弹窗_期权_${props.optionInfo.optionId}`
        });
        window.location.href = `futumm://quote/stockDetailV2?stockID=${props.optionInfo.optionId}`;
    };
    // const toOptionDetail = async (evt) => {
    //     ftReport?.record(evt, { $element_name: `期权弹窗_交易_${props.optionInfo.optionCode}` });
    //     window.location.href
    //     = `futunn://trade/${MARKET_ID_MAP[props.optionInfo.marketType]}/${props.optionInfo.optionCode}`;
    // };
    return {
        $tran,
        isEN,
        isJP,
        toStock,
        toOption
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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